import React from "react";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 56px;
  padding: 0px;
`;

const Span = styled.span`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  color: #5b5555;
  height: 100%;
  display: flex;
  align-items: center;
`;

const Icon = styled.div`
  width: 20px;
  height: 20px;
  position: absolute;
  left: 16px;
  top: 18px;
`;

export default function Header({ button }) {
  return (
    <Container>
      <Span>돌보미 신청하기</Span>
      {button && (
        <Icon>
          <svg
            width="14"
            height="18"
            viewBox="0 0 14 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.915771 8.99757C0.915771 9.33848 1.07628 9.65949 1.349 9.86403L11.3466 17.3622C11.8251 17.7211 12.504 17.6241 12.8629 17.1456C13.2218 16.6671 13.1248 15.9882 12.6463 15.6293L3.80396 8.99757L12.6463 2.36585C13.1248 2.00695 13.2218 1.32808 12.8629 0.849552C12.504 0.371022 11.8251 0.27404 11.3466 0.632938L1.349 8.13112C1.07628 8.33566 0.915771 8.65667 0.915771 8.99757Z"
              fill="#5B5555"
            />
          </svg>
        </Icon>
      )}
    </Container>
  );
}
